(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/distribution.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/distribution.js');

'use strict';

const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const {
  useAtom,
  useAtomValue
} = jotai;
const {
  selectedHighlightedWinGroupAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  wagersAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const formatCurrency = svs.utils.format.Currency;
const {
  wagerHelper
} = svs.lyckoplatsen.shared_mybets_wager.utils;
const {
  useEffect
} = React;
const Distribution = _ref => {
  let {
    result
  } = _ref;
  const wagers = useAtomValue(wagersAtom);
  const distribution = (result === null || result === void 0 ? void 0 : result.distribution) || [];
  const totalAmount = distribution.reduce((acc, dist) => acc + dist.winners * parseInt(dist.amountSek, 10), 0);
  const totalWinners = distribution.reduce((acc, result) => acc + result.winners, 0);
  const [highlightedWinGroup, setHighlightedWinGroup] = useAtom(selectedHighlightedWinGroupAtom);
  const wins = wagerHelper.getWins(wagers, result);
  const winDivWins = wins.map(w => w.winDiv);
  const handleRowClick = index => {
    if (highlightedWinGroup === index) {
      setHighlightedWinGroup(null);
    } else {
      setHighlightedWinGroup(index);
    }
  };
  useEffect(() => setHighlightedWinGroup(null), [setHighlightedWinGroup, result]);
  return React.createElement("div", {
    className: "lp-distribution f-content"
  }, React.createElement("div", {
    className: "distribution-body"
  }, React.createElement("div", {
    className: "distribution-table ".concat(highlightedWinGroup || highlightedWinGroup === 0 ? 'has-selected' : '')
  }, React.createElement("div", {
    className: "table-row row-headers"
  }, React.createElement("div", {
    className: "row-winners"
  }, "Vinnare"), React.createElement("div", {
    className: "row-distance"
  }, "Distans"), React.createElement("div", {
    className: "row-amount"
  }, "Vinst")), distribution.map((item, index) => {
    const classNames = ['table-row'];
    highlightedWinGroup === index && classNames.push('selected');
    winDivWins.includes(index) && classNames.push('win');
    const winners = index === 0 && winDivWins.includes(index) ? 'Du' : "".concat(formatCurrency(item.winners), " st");
    return React.createElement("div", {
      className: classNames.join(' '),
      key: index,
      onClick: () => handleRowClick(index),
      onKeyDown: e => {
        if (e.key === 'Enter') {
          handleRowClick(index);
        }
      },
      tabIndex: 0
    }, React.createElement("div", {
      className: "row-winners"
    }, React.createElement("span", null, winners)), React.createElement("div", {
      className: "row-distance padding-h-1"
    }, index !== 0 && React.createElement("span", null, "< ".concat(svs.lyckoplatsen.utils.format.formatDistance(item.distanceMeters))), index === 0 && React.createElement(PinIcon, {
      color: "white"
    })), React.createElement("div", {
      className: "row-amount"
    }, "".concat(formatCurrency(item.amountSek), " kr"), " "));
  }), React.createElement("div", {
    className: "table-footer"
  }, "Totalt vinstbelopp: ", "".concat(formatCurrency(totalAmount), " kr"), " ", React.createElement("br", null), "Antal vinnare: ", "".concat(formatCurrency(totalWinners), " st")))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  Distribution
});

 })(window);